import moment from "moment";
import i18n from "i18next";
import { getLanguage, getLocalization, Localization } from "./utils";

var CryptoJS = require("crypto-js");
const KEY_TOKEN = "f_a_c";

export enum CrmLanguage {
  IT = "Italiano",
  EN = "Inglese",
  FR = "Francese",
  DE = "Tedesco",
  ES = "Spagnolo",
  IT_EXPORT = "Italiano (Export)",
}

export enum Language {
  IT = "it-IT",
  EN = "en-EN",
  FR = "fr-FR",
  DE = "de-DE",
  ES = "es-ES",
}

export type AuthInfoType = {
  access_token: string;
  refresh_token: string;
  id_user: string;
  crm_language: CrmLanguage;
  crm_country: "United States of America" | string;
  at: number;
  email: string;
};

// AUTH
const setAuthInfo = (
  infoToken: any,
  idUser: string,
  crm_language: string,
  email: string,
  crm_country: string,
  roles: string[]
): void => {
  const _jsonData = {
    ...infoToken,
    id_user: idUser,
    crm_language,
    crm_country,
    roles,
    email,
    at: moment().valueOf(),
  } as AuthInfoType;
  const _data = JSON.stringify(_jsonData);
  console.log("[SET AUTH DATA]", _data);

  localStorage.setItem(
    KEY_TOKEN,
    CryptoJS.AES.encrypt(_data, process.env.REACT_APP_CRYPT_KEY).toString()
  );

  //Set language
  i18n.changeLanguage(getLangFromWPLocale());
};

const getAuthInfo = (): AuthInfoType | any => {
  try {
    const info = localStorage.getItem(KEY_TOKEN);
    const decrypted = info
      ? CryptoJS.AES.decrypt(info, process.env.REACT_APP_CRYPT_KEY)?.toString(
          CryptoJS.enc.Utf8
        )
      : "{}";
    return JSON.parse(decrypted);
  } catch (error) {
    return {};
  }
};

const clearAuthInfo = (): void => {
  localStorage.removeItem(KEY_TOKEN);
};

/**
 * Returns true if the user is logged in, false otherwise.
 * A user is considered logged in if they have a valid access token
 * and the token has not expired. Additionally, if the current market
 * is America, the user must have at least one role. If the current
 * market is not America, the user does not need any roles.
 * @return {boolean} True if the user is logged in, false otherwise.
 */
const isLogged = (): boolean => {
  return (
    !!getAuthInfo()?.access_token &&
    isTokenExpired() !== undefined &&
    !isTokenExpired() &&
    ((!!getAuthInfo()?.roles?.length &&
      getCurrentMarket() === Localization.AMERICA) ||
      getCurrentMarket() !== Localization.AMERICA)
  );
};

const isTokenExpired = (): boolean | undefined => {
  const auth = getAuthInfo();
  if (!auth?.at) return undefined;
  const expire_date_ms = auth?.at + 3600 * 1000;
  return moment().valueOf() > expire_date_ms;
};

const getLangFromWPLocale = (): string | undefined => {
  if (getLocalization() === Localization.AMERICA) return "en";
  else return getLanguage();
};

const setCurrentMarket = (market: string) =>
  sessionStorage.setItem("currentMarket", market);
const getCurrentMarket = () => sessionStorage.getItem("currentMarket");

/**
 * Hanno accesso al mercato americano tutti gli usa e il canada
 * 
 * Hanno accesso ad altro mercato gli utenti non usa 
 * @returns boolean 
 */
export const hasUserAccessToThisMarket = (
  authCountry?: string | null,
  marketOverride?: string | null
) =>
  {
    const country = authCountry ?? getAuthInfo()?.crm_country;
    const market = marketOverride ?? getCurrentMarket();
    if (!market) return false;

    const isUsa = country === "United States of America";
    const isCanada = country === "Canada";
    const isAmericaMarket = market === Localization.AMERICA;

    // Un utente canadese o USA ha accesso al mercato americano
    if (isAmericaMarket) return isUsa || isCanada;

    // Un utente di qualsiasi altra nazione (o nessuna nazione) ha accesso a _qualsiasi_ altro mercato
    return !isUsa && !isCanada;
  };

export {
  setAuthInfo,
  getAuthInfo,
  isLogged,
  isTokenExpired,
  getLangFromWPLocale,
  clearAuthInfo,
  setCurrentMarket,
  getCurrentMarket,
};
